function getEnvVars() {
  const { hostname, host } = window.location;

  const defaultEnv = {
    env: "local",
    clientId: "0oav7ydh4klkBykt9697",
    issuer: "https://integrator-2803487.okta.com/oauth2/default",
    backendUrl: "https://neo-authz-bff-dev-tdzjut3m4a-uc.a.run.app",
    // backendUrl: "http://localhost:8080",
    surveySubmitScreenId: "661076",
    accessRequestMicrofrontendUrl: "http://localhost:3001/static/js/main.js",
    zendeskDomainUrl: "https://twtesting1704358503.zendesk.com/agent/tickets/",
  };

  if (hostname.startsWith("dev-dot-techops-platform-authz")) {
    return {
      ...defaultEnv,
      env: "dev",
      clientId: "0oav7ydh4klkBykt9697",
      issuer: "https://integrator-2803487.okta.com/oauth2/default",
      backendUrl: "https://neo-authz-bff-dev-tdzjut3m4a-uc.a.run.app",
      accessRequestMicrofrontendUrl: "https://dev-ar-authz-techops-tw.web.app/main.js",
    };
  }

  if (hostname.startsWith("test-dot-techops-platform-authz")) {
    return {
      ...defaultEnv,
      env: "test",
      clientId: "0oav83q3laGtEODdK697",
      issuer: "https://integrator-2803487.okta.com/oauth2/default",
      backendUrl: "https://neo-authz-bff-test-tdzjut3m4a-uc.a.run.app",
      accessRequestMicrofrontendUrl: "https://test-ar-authz-techops-tw.web.app/main.js",
    };
  }

  if (hostname.startsWith("staging-dot-techops-platform-authz")) {
    return {
      ...defaultEnv,
      env: "staging",
      clientId: "0oayuxiux9W0XewJ00h7",
      issuer: "https://thoughtworks.oktapreview.com/oauth2/auseakslniuZCJMzf0h7",
      backendUrl: "https://neo-authz-bff-staging-tdzjut3m4a-uc.a.run.app",
      accessRequestMicrofrontendUrl: "https://staging-ar-authz-techops-tw.web.app/main.js",
    };
  }

  if (hostname.startsWith("platform-authz-prod") || hostname.startsWith("authz.thoughtworks.net")) {
    return {
      ...defaultEnv,
      env: "production",
      surveySubmitScreenId: "661526",
      clientId: "0oa1le4g9rq7svXjX0h8",
      issuer: "https://thoughtworks.okta.com/oauth2/default",
      backendUrl: "https://neo-authz-bff-prod-6p4aubtica-uc.a.run.app",
      accessRequestMicrofrontendUrl: "https://ar-authz-techops-tw.web.app/main.js ",
      zendeskDomainUrl: "https://thoughtworks.zendesk.com/agent/tickets/",
    };
  }

  if (host.startsWith("localhost:5000")) {
    return {
      env: "integration-test",
      backendUrl: "https://localhost:8080",
    };
  }
  return defaultEnv;
}

const { env,surveySubmitScreenId, clientId, issuer, backendUrl, accessRequestMicrofrontendUrl, zendeskDomainUrl } =
  getEnvVars();

const config = {
  isEnableReduxDevTool: () => env === "local" || env === "dev",
  isProd: () => env === "production",
  isStaging: () => env === "staging",
  isDev: () => env === "dev",
  isLocalTestEnvironment: () => env === "integration-test" || env === "e2e-test",
  oktaConfig: {
    clientId: clientId,
    issuer: issuer,
    redirectUri: window.location.origin + "/login/callback",
    scopes: ["openid", "profile", "email"],
    pkce: true,
    disableHttpsCheck: true,
  },
  backendUrl: backendUrl,
  accessRequestMicrofrontendUrl: accessRequestMicrofrontendUrl,
  zendeskDomainUrl: zendeskDomainUrl,
  surveySubmitScreenId
};

export default config;
